export enum SocialProviders {
    Facebook = 'facebook'
}
